<template>
    <div class="modal" tabindex="-1" role="dialog" :id="modalId">
        <div class="modal-dialog m-0" role="document">
            <div class="modal-content" style="border-radius: 0">
                <div
                    class="modal-body p-0 vh-100 d-flex justify-content-center align-items-center"
                    style="background-color: black;"
                >
                    <img
                        src="@/assets/icons/close-white.svg"
                        alt=""
                        style="position:absolute; top: 20px; left: 20px; border-radius: 50%; background-color: #00000080"
                        @click="close()"
                    />
                    <iframe
                        v-if="isVideo"
                        style="width: 100vw; height: 100vh"
                        :src="url"
                        title="description"
                    ></iframe>
                    <img v-else :src="url" class="w-100" alt="" style="height: 100%"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

export default {
    name: 'ImagePreview',
    components: {
        SOTitleBar
    },
    props: {
        modalId: {
            type: String,
            default: 'modalImagePreview'
        }
    },
    data() {
        return {
            url: null,
            contentType: null,
            isVideo: false,
        }
    },
    methods: {
        close() {
            $("#" + this.modalId).modal("hide");
        },
        open(imageSrc, contentType) {
            this.url = imageSrc
            this.contentType = contentType
            this.isVideo = contentType.includes('video')
            $("#" + this.modalId).modal("show");
        }
    }
}
</script>

<style scoped>
</style>